'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '入力された内容に誤りがあります';